import { isHoliday } from "feiertagejs";
import type { Moment } from "../date";
import type { Tables } from "../types";

/**
 * Whether the contract schedules this person to work on a given day.
 *
 * `workdays` is a set of `moment().weekday()` values, and the `de` locale in `@msuite/utils/date`
 * makes weekday 0 a Monday — the reading `getAbsenceDays` and `getTakenVacationDays` already give
 * it. A public holiday in the employment's own `region` is not scheduled either, which is what that
 * column is on the record for.
 *
 * A day no employment covers falls back to Monday–Friday: somebody with no contract on file would
 * otherwise have every day count as off schedule.
 *
 * @param employment - The contract in force on the day, or `null` when none is.
 * @param dateMoment - The day in question.
 * @returns `true` when the day is a scheduled working day.
 */
export function getIsScheduledDay(
	employment: Tables<"employments"> | null,
	dateMoment: Moment,
): boolean {
	if (!employment) return dateMoment.weekday() <= 4;
	if (!employment.workdays.includes(dateMoment.weekday())) return false;
	return !isHoliday(dateMoment.toDate(), employment.region);
}
